import { AspectRatio, Box, Heading } from "@/ui";

export default function WarningOverlay({ children, deviceName }: { children: any; deviceName: string }) {
  return (
    <Box width="100%" pos="absolute" borderRadius="1.5rem" bg="#000000" zIndex={2}>
      <AspectRatio ratio={16 / 9}>
        <Box>
          <Box width="100%" h="100%">
            <Heading as="h5" pt="2rem" color="white" textAlign="center">
              {deviceName}
            </Heading>
            {children}
          </Box>
        </Box>
      </AspectRatio>
    </Box>
  );
}
